<template>
    <Navbar :rightBtn="true" :title="NavbarTitle"></Navbar>
    <div class="policy-detail-service">
        <img class="img-bg" src="@/assets/images/policy_match.png" />
        <div class="header">
            <div class="title-box">
                <div class="title-s"> {{detail.name}}</div>
                <div class="field-normal">
                    <div class="field-item">
                        <span class="field-label">阅读量:</span>
                        <span class="field-value">{{ detail.click_num }}</span>
                    </div>
                    <div class="field-item">
                        <span class="field-label">已办理:</span>
                        <span class="field-value">{{ detail.handle_num }}件</span>
                    </div>
                </div>
            </div>
            <div class="swiper-box small">
                <div v-if="imgArr.length">
                    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
                        <van-swipe-item v-for="item in imgArr" :key="item">
                            <img class="img" :src="item" v-if="item" />
                        </van-swipe-item>
                    </van-swipe>
                </div>
                
                <van-swipe  v-else-if="detail.id==6"  :autoplay="3000" lazy-render>
                    <van-swipe-item v-for="image in imgAcc" :key="image">
                        <img class="iconimg" v-lazy="image" :src="image" >
                    </van-swipe-item>
                </van-swipe>
                <div class="my-swipe"  v-else>
                    <img class="img" src="@/assets/images/mall/img_swiper_d.jpg" />
                </div> 

            </div>
        </div>
        <div class="policy-detail-service-content">
            <!-- <div class="content-b" v-if="detail.id!=5">
                <div class="title-s-c">{{detail.name}}</div>
            </div>  -->
            <div class="provider"  v-html="detail.content">
            </div>
                <!-- <img class="iconimg" v-if="detail.id==8"  v-for="img in imgLists" v-lazy="img" />
                <img class="iconimg" v-if="detail.id==7"  v-for="img in imgLists2" v-lazy="img" />
                <img class="iconimg" v-if="detail.id==6" v-for="img in imgLists3" v-lazy="img" /> -->
        </div>
        <div v-if="detail.id==5"  class="policy-detail-service-content">
            <div class="content-b">
                <div class="title-s-c">{{detail.name}}</div>
                <div class="card">
                    <div class="card-title">
                        <div class="flex-title-text">
                            服务商简述
                        </div>
                    </div>
                    <div class="card-content" v-if="detail.description">
                        <div v-html="detail.description"></div>
                    </div>
                </div>
            </div> 
        </div>
        <div v-if="detail.id==5" class="policy-detail-service-content">
            <div class="content-b ">
                <div class="card">
                    <div class="card-title">
                        <div class="flex-title-text">
                            服务商详细信息
                        </div>
                    </div>
                    <div class="card-content" v-if="detail.content">
                        <div class="detail-img-b" v-html="detail.content"></div>
                    </div>
                </div>
            </div>
             
        </div>

        <div class="policy-detail-service-content">
            <div class="content-b">
                <div class="card">
                    <div class="title-tel">
                        联系方式
                    </div>
                    <div class="card-content">
                        <!-- <div @click="doTel">联系电话: {{detail.phone}}</div> -->
                        <div>地    址: {{detail.address}}</div>
                        <div v-if="detail.email">电子邮箱: {{detail.email}}</div>
                        <!-- <div>账号管理员(技术支持): {{detail.phone}}</div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="float-action">
        <div class="flex-item btn-collect-box">
            <van-button class="btn btn-collect btn-favorite" v-if="!favorite" @click="doFav(true)">
                <!-- <van-icon class="icon" name="star" color="#fff" size="20" /> -->
                <img class="icon-favorite" src="@/assets/images/icon_favorite_1@2x.png">
                收藏
            </van-button>
            <van-button class="btn btn-favorite btn-favorite-active" v-else @click="doFav(false)">
                <!-- <van-icon class="icon" name="star-o" color="#ffe4a8" size="20" /> -->
                <img class="icon-favorite" src="@/assets/images/icon_favorite_2@2x.png">
                取消收藏
            </van-button>
        </div>
        <div class="flex-item btn-consult-box" v-if="btnType == '1'">
            <van-button class="btn btn-consult" @click="doDeclare">
                <van-icon class="icon" name="chat-o" color="#fff" size="20" />
                一键咨询
            </van-button>
        </div>
    </div>
</template>

<script>

// import { Dialog, Notify } from "vant"
import { getServiceQueryById, addFavoritev3, cancelFavoritev3, queryFavorite,companyQueryByUserId,getImgUrl,queryUserById } from "@/api/home"
// import moment from "moment"
import Navbar from '@/components/Navbar'
import PolicyDetailHeader from "@/components/PolicyDetailHeader.vue"
import { clickUrlToPhone } from '@/utils/index'
// import imgDefault from '@/assets/images/mall/img_swiper_d.jpg'

export default {

    data() {
        return {
            imgAcc:[
                
					require('../../assets/gzlb/gzlb- 1.jpg'),
					require('../../assets/gzlb/gzlb- 2.jpg'),
					require('../../assets/gzlb/gzlb- 3.jpg'),
					require('../../assets/gzlb/gzlb- 4.jpg'),
					require('../../assets/gzlb/gzlb- 5.jpg'),
            ],
            detail: {},
            imgArr:[],
            NavbarTitle: '',
            btnType: 0,
            favorite: false,
            company: {},
            favFlag: false,
            imgLists:[
				{
					src:require("../../assets/ruiyan/ruiyan_01.jpg"),
					show:true
				},
				{
					src:require("../../assets/ruiyan/ruiyan_02.jpg"),
					show:true
				},
				{
					src:require("../../assets/ruiyan/ruiyan_03.jpg"),
					show:true
				},
				{
					src:require("../../assets/ruiyan/ruiyan_04.jpg"),
					show:true
				},
				{
					src:require("../../assets/ruiyan/ruiyan_05.jpg"),
					show:true
				},
				{
					src:require("../../assets/ruiyan/ruiyan_06.jpg"),
					show:true
				},
				{
					src:require("../../assets/ruiyan/ruiyan_07.jpg"),
					show:true
				},
	
			],
            imgLists2:[
				{
					src:require("../../assets/klcx/klcx_01.jpg"),
					show:true
				},
				{
					src:require("../../assets/klcx/klcx_02.jpg"),
					show:true
				},
				{
					src:require("../../assets/klcx/klcx_03.jpg"),
					show:true
				},
				{
					src:require("../../assets/klcx/klcx_04.jpg"),
					show:true
				},
				{
					src:require("../../assets/klcx/klcx_05.jpg"),
					show:true
				},
				{
					src:require("../../assets/klcx/klcx_06.jpg"),
					show:true
				},
				{
					src:require("../../assets/klcx/klcx_07.jpg"),
					show:true
				},
				{
					src:require("../../assets/klcx/klcx_08.jpg"),
					show:true
				},
				{
					src:require("../../assets/klcx/klcx_09.jpg"),
					show:true
				},
				{
					src:require("../../assets/klcx/klcx_10.jpg"),
					show:true
				},
			
	
			],
            imgLists3:[
				{
					src:require("../../assets/guozai/guozai_01.jpg"),
					show:true
				},
				{
					src:require("../../assets/guozai/guozai_02.jpg"),
					show:true
				},
				{
					src:require("../../assets/guozai/guozai_03.jpg"),
					show:true
				},
				{
					src:require("../../assets/guozai/guozai_04.jpg"),
					show:true
				},
				{
					src:require("../../assets/guozai/guozai_05.jpg"),
					show:true
				},
				{
					src:require("../../assets/guozai/guozai_06.jpg"),
					show:true
				},
				{
					src:require("../../assets/guozai/guozai_07.jpg"),
					show:true
				},
				{
					src:require("../../assets/guozai/guozai_08.jpg"),
					show:true
				},
				{
					src:require("../../assets/guozai/guozai_09.jpg"),
					show:true
				},
				{
					src:require("../../assets/guozai/guozai_10.jpg"),
					show:true
				},
				{
					src:require("../../assets/guozai/guozai_11.jpg"),
					show:true
				},
			
	
			],
			imgNodeList:[]
        }
    },
    components: {  Navbar, PolicyDetailHeader },
    computed: {},
    watch: {},
    mounted() {
        this.init()
        this.imgNodeList = $('.out_wrap .img_wrap').toArray()
		this.scroll()
    },
    methods: {
        load(item){
		item.show=false
	},
	scroll(e){
		//如果列表为空则不进入下一层
        console.log(this.imgNodeList);
		if(!this.imgNodeList.length) return
		//获取最外层的高度
		let seeH = $('.out_wrap').height()
		//遍历图片列表，取出img,如果已经赋值则在imgList中移除，否则获取该图片的位置，在到达该位置赋值
		this.imgNodeList.forEach((img,index)=>{
			//取出img
			let imgItem = $(img).children().first()
			
			// 获取该图片的位置
			let itemP =$(img).position().top
			
			//在到达该位置赋值
			if(itemP<seeH+50){
				imgItem.attr('src',imgItem.attr('data-src')).removeAttr('data-src')
			}

			//如果已经赋值则在imgList中移除
			if(imgItem.attr('src')){
				this.imgNodeList.splice(index,1)
				return
			}
		})
	},
        init() {
            this.id = this.$route.query.id
            this.NavbarTitle = this.$route.query.title
            this.btnType = this.$route.query.btnType
            this.getData()
        },
        async doFav(type) {
            if(this.favFlag){
                return false
            }
            this.favFlag = true
            const request = type ? addFavoritev3 : cancelFavoritev3
            let res = await request({ 'provider_id': this.id })
            this.$toast.success({ message: type ? '收藏成功' : '取消收藏成功', duration: 2000 })
            setTimeout(() => {
                this.favFlag = false
                this.getData()
            }, 2000)
        },
        async getData() {
            let res = await getServiceQueryById({ 'id': this.id })
            this.detail = res.result
            this.imgArr = res.result.imgs ? res.result.imgs.split(',') : []
            this.favorite = res.result.favorite ? true : false
        },
        doDeclare() {
            let query = {
                type:'getPhone',
                serviceProviderId:this.detail.id
            }
            clickUrlToPhone('',query)
            console.log(1);
        },
        doTel(){
            clickUrlToPhone('', { phone: this.detail.phone, type: 'getTel' })
        }
    }
}
</script>

<style lang="scss" scoped>
.iconimg {
    height: 200px;
    width:100%
}
.policy-detail-service{
    overflow-x: hidden;
    background: #f3f3f3;
    position: relative;
    padding-bottom: 100px;
    .img-bg {
        height: 220px;
        width: 100%;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        z-index: 0;
    }
     .header {
        position: relative;
        z-index: 5;
        padding-top: 17px;
        margin: 0 17px 30px;
    }
    .title-box{
        color: #fff;
        font-size: 12px;
        margin-bottom: 18px;
        .title-s{
            font-size: 18px;
            font-weight: 600;
            margin-bottom: 5px;
        }
    }

    .swiper-box{
        height: 192px;
        box-shadow: 0px 4px 4px 1px rgba(44, 76, 113, 0.25);
        border-radius: 8px;
        background: #fff;
        .my-swipe{
            width: 100%;
            height: 192px;
            img{
                width: 100%;
                height: 100%;
                // background-size: 100% 100%;
                background-size: cover;
                border-radius: 8px;
            }
        }
        
    }

.policy-detail-service-content{
    background: #f3f3f3;
    box-shadow: 0px -4px 8px 1px rgba(160, 198, 210, 0.25);
    border-radius: 8px;
    margin-bottom: 12px;
    .content-b{
        padding: 15px;
        background: #fff;
        border-radius: 8px;
    }
}
    .title-s-c{
        font-size: 22px;
        font-family: 'PingFang SC-Semibold, PingFang SC';
        font-weight: 600;
        color: #373837;
        line-height: 26px;
        margin-bottom: 15px;
    }
    .card {
    width: 100%;
    margin-bottom: 30px;
  }

  .card-title {
    font-size: 14px;
    display: flex;
    align-items: center;
    font-weight: bold;
    display: flex;
    margin-bottom: 8px;
    color: #0C9DE9;

    &:before {
      content: '';
      height: 16px;
      margin-right: 5px;
      border-left: 4px solid #0C9DE9;
    }
  }

.policy-detail-c-box{
    width: 100%;
    background-size: 100% 100%;
    
    .card{
        padding: 75px 15px 0;
    }
    .card-content {
        background: transparent;
    }
}
  .card-content {
    background: #fff;
    margin-bottom: 16px;
    font-size: 12px;
    color: #000;
  }
  .title-tel{
    font-size: 18px;
    font-weight: 600;
    color: #585858;
    margin-bottom: 10px;
  }

  .detail-img-b{
      width: 100%;
      img{
          width: 100%;
          background-size: contain;
      }
  }
}

	.iconimg{
       display: block; 
    height: auto;
    margin: auto;
    max-width: 100%;
	}
	
	.out_wrap{
		position: fixed;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		overflow-y: scroll;
		background-color: whitesmoke;
	}
	
	.loading{
		width: 300px;
		height: 800px;
		background-color: red;
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
	}
	
	.img_wrap{
		width: fit-content;
	}
 v::deep .van-swipe__track {
        height: 200px;
  }
</style>
<style lang="scss">
.provider {
    img {
        display: block !important; 
        height: auto !important;
        max-width: 100% !important;
        object-fit: cover;
    }
}
</style>
